import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";

const baseUrl = config.api.baseUrl;

const getNotifTemplatesDuck = createDuck('GET_NOTIF_TEMPLATES');

const getNotifTemplatesThunk = (params) => {
 
  const url = `${baseUrl}/getNotifTemplates`;
  return createThunk(axios, 'post', getNotifTemplatesDuck.actions, url, params);
};

const crearNotifTemplateDuck = createDuck("CREAR_NOTIF_TEMPLATE");

const crearNotifTemplateThunk = (data) => {
  const url = `${baseUrl}/addNotifTemplate/`;
  return createThunk(axios, "post", crearNotifTemplateDuck.actions, url, data);
};

const editarNotifTemplateDuck = createDuck("EDITAR_NOTIF_TEMPLATE");

const editarNotifTemplateThunk = (data) => {
  const url = `${baseUrl}/editNotifTemplate/`;
  return createThunk(axios, "post", editarNotifTemplateDuck.actions, url, data);
};

const exps = {
  getNotifTemplatesDuck,
  getNotifTemplatesThunk,
  crearNotifTemplateDuck,
  crearNotifTemplateThunk,
  editarNotifTemplateDuck,
  editarNotifTemplateThunk,
};

export default exps;
